define(function(require, exports, module) {
    'use strict';
    const user = require('user');
    const core = require('core');
    const authManager = require('auth');
    const config = require('config');

    module.exports = {
        notify: function() {
            // prevent to show logout popup
            if (user.get('suspended')) {
                user.unset('suspended');
                return;
            }

            authManager.quietLogout();

            window.Playtech.API.popup.showPopup('logoutNotification', {
                isLoginAgainPopup: config.get('isLoginAgainPopup'),
                onAccept: () => core.trigger('app:action:loginPopup'),
                className: 'logout-notification-popup',
                onDecline: () => {
                    // if (config.get('loginPage')) {
                    //     core.navigate(config.get('rootPage'));
                    // }
                }
            });
        }
    };
});
